export default __webpack_public_path__ + "static/media/ls-b.e253cb27.png";